"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityList = exports.EntityListDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_row_1 = require("./entity-row");
var lodash_1 = require("lodash");
var cn_1 = require("../../utils/cn");
var use_entities_1 = require("../../hooks/use-entities");
var current_user_can_1 = require("../../utils/current-user-can");
var use_active_person_1 = require("../../hooks/use-active-person");
var entity_link_value_1 = require("./entity-link-value");
var cls = (0, cn_1.classNames)('entity-list');
exports.EntityListDefaultProps = {
  items: [],
  padFirst: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%; \n  "], ["\n    box-sizing: border-box;\n    width: 100%; \n  "])))
});
var ItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    ", "\n  "], ["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n\n    ", "\n  "])), function (props) {
    return props.useValueComponent && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: flex;\n      flex-wrap: wrap;\n    "], ["\n      display: flex;\n      flex-wrap: wrap;\n    "])));
  })
});
var ItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n    \n\n    ", "\n\n    ", "\n\n    ", "\n      \n    \n    ", "\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    box-sizing: border-box;\n    padding-bottom: ", ";\n    \n\n    ", "\n\n    ", "\n\n    ", "\n      \n    \n    ", "\n  "])), theme_1.theme.UNIT(4), function (props) {
    return !props.showDividerForLast && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:last-child {\n        background: none;\n        padding-bottom: 0;\n\n      }\n    "], ["\n      &:last-child {\n        background: none;\n        padding-bottom: 0;\n\n      }\n    "])));
  }, function (props) {
    return props.showDividers && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "], ["\n      ", ";\n      padding-top: ", ";\n      padding-bottom: ", ";\n    "])), theme_1.theme.H_DOT_BG_END('line-mid'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4, 2));
  }, function (props) {
    return !props.padFirst && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      &:first-child {\n        padding-top: 0;\n      }\n    "], ["\n      &:first-child {\n        padding-top: 0;\n      }\n    "])));
  }, function (props) {
    return props.useLinks && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      &:hover {\n        color: ", ";\n        .sh-entity-bubble-image {\n          //outline: 1px solid ", ";\n        }\n      }\n    "], ["\n      &:hover {\n        color: ", ";\n        .sh-entity-bubble-image {\n          //outline: 1px solid ", ";\n        }\n      }\n    "])), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'));
  }),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.useValueComponent && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-right: ", ";\n      width: auto;\n      flex-basis: 33%;\n    "], ["\n      padding-right: ", ";\n      width: auto;\n      flex-basis: 33%;\n    "])), theme_1.theme.UNIT(4));
  })
});
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled_components_1.default.ul(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled_components_1.default.li(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Row: (0, styled_components_1.default)(entity_row_1.EntityRow)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Value: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
var EntityList = function (props) {
  var className = props.className,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    onItemClick = props.onItemClick,
    namePath = props.namePath,
    padFirst = props.padFirst,
    showDividerForLast = props.showDividerForLast,
    useValueComponent = props.useValueComponent,
    rowProps = __rest(props, ["className", "items", "onItemClick", "namePath", "padFirst", "showDividerForLast", "useValueComponent"]);
  var showDividers = props.showDividers === undefined ? props.showDescription : props.showDividers;
  var ValueComponent = props.valueComponent || My.Value;
  var RowComponent = props.rowComponent || My.Row;
  var entities = (0, use_entities_1.useEntities)();
  var user = (0, use_active_person_1.useActivePerson)();
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Items, {
    useValueComponent: useValueComponent
  }, (0, lodash_1.filter)(items.map(function (entity) {
    var entityTypeName = entity.__typename;
    var defn = entities[entityTypeName];
    if (defn) {
      var namePath_1 = props.namePath || defn.valueNamePath;
      var name_1 = (0, lodash_1.get)(entity, namePath_1, '');
      var useLinks = defn && rowProps.useLinks && (0, current_user_can_1.personCanRead)(user, defn.scopeSlug);
      return react_1.default.createElement(My.Item, {
        useValueComponent: useValueComponent,
        className: cls.sub('item'),
        padFirst: padFirst,
        useLinks: useLinks,
        showDividerForLast: showDividerForLast,
        showDividers: showDividers,
        onClick: onItemClick,
        key: entity.id
      }, useValueComponent ? react_1.default.createElement(ValueComponent, __assign({
        entity: entity,
        name: name_1
      }, rowProps)) : react_1.default.createElement(RowComponent, __assign({
        entity: entity,
        name: name_1
      }, rowProps)));
    }
    return null;
  }))));
};
exports.EntityList = EntityList;
exports.EntityList.cls = cls;
exports.EntityList.defaultProps = exports.EntityListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;